import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import moment from 'moment';
import { getTimeArrayFromRangeKey } from './pickerParseRangeValues';
export default {
  name: 'CoreDateTimePicker',
  props: {
    from: {
      type: Number,
      default: null,
      required: false
    },
    to: {
      type: Number,
      default: null,
      required: false
    },
    allowNull: {
      type: Boolean,
      default: false,
      required: false
    },
    isRange: {
      type: Boolean,
      default: false,
      required: false
    },
    initialRange: {
      type: String,
      default: 'now-10m'
    },
    dateOnly: {
      type: Boolean,
      default: false,
      required: false
    },
    futureRange: {
      type: Boolean,
      default: false,
      required: false
    },
    defaultExpand: {
      type: Boolean,
      default: false,
      required: false
    },
    hideBorderOnCollapse: {
      type: Boolean,
      default: false,
      required: false
    },
    expandIcon: {
      type: String,
      default: 'fal fa-angle-down',
      required: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      expanded: [],
      menu: false,
      startDate: null,
      endDate: null,
      isDatePickerFormValid: true,
      inputValidationRules: {
        validDate: function validDate(value) {
          return _this.validateInputDate(value) || _this.$i18n_t('Core.DateTimePicker.errorHintInvalidDate');
        },
        validRangeStart: function validRangeStart(value) {
          return _this.validateInputRange(value, undefined) || _this.$i18n_t('Core.DateTimePicker.errorHintStartAfterEnd');
        },
        validRangeEnd: function validRangeEnd(value) {
          return _this.validateInputRange(undefined, value) || _this.$i18n_t('Core.DateTimePicker.errorHintEndBeforeStart');
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    mathOp: function mathOp() {
      return this.futureRange ? '+' : '-';
    },
    expansionPanelsClass: function expansionPanelsClass() {
      return this.hideBorderOnCollapse ? '' : 'kpi-card-text-01';
    }
  }),
  watch: {
    initialRange: function initialRange() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    from: function from() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
    },
    to: function to() {
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    defaultExpand: function defaultExpand() {
      this.expanded = this.defaultExpand ? 0 : [];
    }
  },
  mounted: function mounted() {
    this.startDate = parseInt(this.from, 10) || null;
    this.endDate = parseInt(this.to, 10) || null;
    this.expanded = this.defaultExpand ? 0 : [];
    this.init();
  },
  methods: {
    getExpandIcon: function getExpandIcon(attr) {
      return attr === 'true' ? 'fal fa-angle-up' : 'fal fa-angle-down';
    },
    init: function init() {
      moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);

      if (this.startDate === null || this.isRange && this.endDate === null) {
        var times = getTimeArrayFromRangeKey(this.initialRange);
        this.startDate = this.startDate || (this.allowNull ? null : times[0]);
        this.endDate = this.endDate || (this.allowNull ? null : times[1]);
      }
    },
    getIsoDateStringFromUnix: function getIsoDateStringFromUnix(unixTimestamp) {
      return moment(unixTimestamp * 1000).format('YYYY-MM-DD');
    },
    getUnixFromIsoDate: function getUnixFromIsoDate(isoDateString) {
      return moment(isoDateString).unix();
    },
    getUnixFromLocaleDate: function getUnixFromLocaleDate(dateLocaleString) {
      return moment(dateLocaleString, this.dateOnly ? 'll' : 'lll', this.getLocale()).unix();
    },
    getLocale: function getLocale() {
      return this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language;
    },
    getLocaleDateFromUnix: function getLocaleDateFromUnix(unixTimestamp) {
      if (unixTimestamp === null) {
        return '';
      }

      return moment(unixTimestamp * 1000).locale(this.getLocale()).format(this.dateOnly ? 'll' : 'lll');
    },
    handleQuickRangeClick: function handleQuickRangeClick(rangeKey, soFar) {
      var times = getTimeArrayFromRangeKey(rangeKey, soFar);
      this.startDate = times[0];
      this.endDate = times[1];
      this.handleApplyClick();
    },
    handleApplyClick: function handleApplyClick() {
      if (this.validateInputDate(this.startDate) && this.validateInputDate(this.endDate) && this.validateInputRange(this.startDate, this.endDate)) {
        this.$emit('date:picked', {
          from: this.startDate,
          to: this.isRange ? this.endDate : undefined
        });
        this.expanded = [];
      }
    },
    handleStartDateChange: function handleStartDateChange(value) {
      var unixTimestamp = moment(value, this.dateOnly ? 'll' : 'lll', this.getLocale()).unix();

      if (!isNaN(unixTimestamp)) {
        this.startDate = unixTimestamp;
        this.$refs.formDatePicker.validate();
      }
    },
    handleEndDateChange: function handleEndDateChange(inputDateString) {
      var timestamp = this.getUnixFromLocaleDate(inputDateString);

      if (!isNaN(timestamp)) {
        this.endDate = timestamp;
        this.$refs.formDatePicker.validate();
      }
    },
    handleStartDatePicked: function handleStartDatePicked(isoDate) {
      this.startDate = moment(isoDate).unix();
      this.$refs.formDatePicker.validate();
    },
    handleEndDatePicked: function handleEndDatePicked(isoDate) {
      this.endDate = moment(isoDate).endOf('day').unix();
      this.$refs.formDatePicker.validate();
    },
    validateInputDate: function validateInputDate(inputDate) {
      var inputTS = isNaN(inputDate) ? this.getUnixFromLocaleDate(inputDate) : inputDate;
      return moment(inputTS * 1000).isValid();
    },
    validateInputRange: function validateInputRange() {
      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startDate;
      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.endDate;

      // ignore rangecheck if component is not working with time ranges
      if (!this.isRange) {
        return true;
      }

      var startTS = isNaN(startDate) ? this.getUnixFromLocaleDate(startDate) : startDate;
      var endTS = isNaN(endDate) ? this.getUnixFromLocaleDate(endDate) : endDate;
      return moment(startTS * 1000).isBefore(endTS * 1000);
    }
  }
};